
import { Link } from "react-router-dom";
import React, { useRef } from "react";
import Hero from "./Hero"

function Banner({ heroRef }) {
  const contactRef = useRef(null);
  const scrollToHero = () => {
    if (heroRef && heroRef.current) {
      heroRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  
  return (
    <section>
      <div class="bg-[#7fbb00] font-sans min-h-[450px] relative max-w-full mx-auto rounded overflow-hidden p-2">
        <div class="grid lg:grid-cols-2 w-full h-full absolute inset-0">
          <div class="p-4 max-lg:hidden">
            <img
              src="https://readymadeui.com/image-1.webp"
              class="object-cover w-full h-full"
              alt="img"
            />
          </div>

          <div class="flex flex-col items-end justify-center text-right px-8 relative bg-[#262464] rounded-tl-[206px] z-20 before:absolute before:inset-0 before:!left-auto before:bg-[#293587] before:w-2/3 before:rounded-bl-[206px] before:-z-10">
            <h3 class="font-bold sm:text-4xl text-2xl text-yellow-400">
              Expert-Driven Research
            </h3>
            <p class="text-sm text-gray-300 mt-4">
              {" "}
              Our research report are backed by extensive research.
            </p>

            {/* <button
              type="button"
              class="mt-6 bg-[#7fbb00] text-white text-base py-2 px-6 border border-white rounded-full hover:bg-white hover:text-black transition duration-300"
            >
           
            Book Now
              
            </button> */}
            <button
                onClick={scrollToHero}
                type="button"
                className="mt-6 bg-[#7fbb00] text-white text-base py-2 px-6 border border-white rounded-full hover:bg-white hover:text-black transition duration-300"
                
              >
                Book Now
              </button>
          </div>
        </div>
      </div>
      {/* <div ref={contactRef}>
        <Hero />
      </div> */}
    </section>
  );
}

export default Banner;
